import axios from 'axios'

export default {
    signup: (data) => axios.post('freelancers/signup', data),
    login: (data) => axios.post('freelancers/login', data),
    forceLogin : (data) => axios.post('login/force', data),
    forceAdminLogin : (data) => axios.post('admin-login/force', data),
    
    loginPartner: (access_token) => axios.post('login-partner', {access_token: access_token}),
    loginOwner: (access_token, account_id) => axios.post('login-owner', {access_token: access_token, account_id: account_id}),
    validate: (data) => axios.post('freelancers/validate', data),
    validateAdmin: (data) => axios.post('freelancers/admin-validate', data),
    validateRFC: (rfc) => axios.post('validate-rfc', {rfc: rfc}),
    validateEmail: (email) => axios.post('validate-email', {email: email}),
    getUser: (id) => axios.post('get-user', {id: id}),
    activateAccount: (data) => axios.post('account/activate', data),
    recoveryAccount: (data) => axios.post('account/send-recover-password-link', data),
    recoveryPassword: (data) => axios.post('account/recover-password', data),
    storeAccount: (data) => axios.post('account/store', data),
    storeOwnerAccount: (data) => axios.post('account/owner-store', data),

    validateDailyCode: (data) => axios.post('validate-daily-code', data),
}